import React, { FC, useState, useEffect, useRef } from 'react'

import TextInput from '../../UI/Inputs/TextInput';
import SelectInput from '../../UI/Inputs/SelectInput';
import CustomButton from '../../UI/Buttons/CustomButton';
import Checkbox from '../../UI/Inputs/Checkbox';
import Form from '../../Form';

import { useDispatch } from '../../../store';
import { setCardFormatAction } from '../../../store/billing/slice'

import { FormikHelpers } from 'formik';
import { TCardFormValues } from '../../../models/form';
import ErrorMessage from '../../../components/UI/Tooltips/ErrorMessage';
import './CreditCard.scss'

interface AddCardProps {
    inProgress: boolean,
    error: any,
    saveCallBack: any,
    showDescription?: boolean,
    isEditable?: boolean,
    cardDetails: TCardFormValues
}

const CreditCard: FC<AddCardProps> = ({ inProgress, saveCallBack, showDescription, isEditable = false, cardDetails, error }) => {

    const [disableField, setDisableField] = useState(false);
    const [isTouched, setIsTouched] = useState(false);
    const dispatch = useDispatch();
    const ref = useRef<any>(null);

    useEffect(() => {
        setDisableField(isEditable);
    }, [isEditable])

    useEffect(() => {
        if (isEditable && inProgress == false && !error) {
            setDisableField(true);
        }
    }, [isEditable, inProgress, error])

    const currentDate = new Date();
    const monthList: Array<{ label: string, value: number }> = new Array(12).fill(1).map((v, k) => {
        const value = (v + k) > 9 ? `${(v + k)}` : `0${v + k}`
        return { label: value, value: Number(value) }
    });
    const yearList: Array<{ label: string, value: number }> = new Array(11).fill(1).map((v, k) => {
        const date = currentDate.getFullYear();
        return { label: `${Number(date) + k}`, value: Number(date) + k }
    });


    const onChangeCard = (event: any) => {
        const { target: { value } } = event;
        const val = value.replace(/\W/gi, '').replace(/(.{4})/g, '$1 ');
        ref.current.values.cardNumber = val.trim();
        const refValues = ref.current.values;
        dispatch(setCardFormatAction({ ...refValues, cardNumber: val.trim() }))
    }

    const onChangeCardOnBlur = (event:any)=>{  
        const { target: { value } } = event;
        const val = value.replace(/\W/gi, '').replace(/(.{4})/g, '$1 ');
        ref.current.values.cardNumber = val.trim() ;
        const refValues = ref.current.values;
        dispatch(setCardFormatAction({ ...refValues, cardNumber: val.trim() }))
        setIsTouched(true)    
    }

    const disablehandler = () => {
        setDisableField(false)
        const refValues = ref.current.values;
        dispatch(setCardFormatAction({ ...refValues, cardNumber: '' }))
    }

    const onChangeTax = (value:boolean) => {
        const refValues = ref.current.values;
        dispatch(setCardFormatAction({ ...refValues, hasTax:value }))
    }
    
    const setUpForm = {
        initialValues: {
            cardName: cardDetails.cardName || '',
            cardNumber: cardDetails.cardNumber,
            expiryMonth: cardDetails.expiryMonth,
            expiryYear: cardDetails.expiryYear,
            cvc: !isEditable && cardDetails.cvc ? cardDetails.cvc : '',
            hasTax: cardDetails.hasTax ?cardDetails.hasTax:false
        },
        validation: !isEditable && cardDetails.cardNumber && !isTouched?'':'card',
        enableReinitialize: true,
        onSubmit: async (values: TCardFormValues, actions: FormikHelpers<TCardFormValues>) => {
            let touchedStatus = isTouched
            if( values.expiryMonth !== cardDetails.expiryMonth  || values.expiryYear !== cardDetails.expiryYear){
                touchedStatus = true;
                setIsTouched(touchedStatus)
            }
            saveCallBack({data:{ ...values, cardNumber: values.cardNumber.replace(/\s/g, ''), expiryMonth: Number(values.expiryMonth), cvc: values.cvc,country:values.hasTax?'AU':'' },state:{touched:touchedStatus}});
        }
    }

    return (

        <div className="card-container">
            <Form {...setUpForm} innerRef={ref}>
                <TextInput label="Card Holder Name" name="cardName" disabled={disableField} onBlur={()=>setIsTouched(true)} />
                <TextInput label="Card Number" name="cardNumber" maxLength="19" disabled={disableField} placeholder={isEditable || cardDetails.cardNumber ? cardDetails.cardNumber : ''} onKeyPress={onChangeCard} onBlur={($event:any)=>onChangeCardOnBlur($event)} />
                <div className='card-container__row'>
                    <div className="card-container__row__expiry-dates">
                        <SelectInput disabled={disableField}
                            label='Month'
                            name='expiryMonth'
                            placeholder='MM'
                            options={monthList}
                        />
                        <SelectInput disabled={disableField}
                            label='Year'
                            name='expiryYear'
                            placeholder='YYYY'
                            options={yearList}
                        />
                    </div>
                    <TextInput label="CVC" name="cvc" maxLength="4" placeholder={'****'} disabled={disableField}  onBlur={()=>setIsTouched(true)} />
                </div>
                {!isEditable ? <div className='card-container__row'>
                    <Checkbox label="Are you an Australian registered company?" name="hasTax"
                    checked={cardDetails.hasTax}
                    onChange={({ target: { checked } }: React.ChangeEvent<HTMLInputElement>) =>
                    onChangeTax(checked)
                    }
                    onBlur={()=>setIsTouched(true)}
                    />
                </div> : null}
                {showDescription ? <div className="card-container__form__description" >
                    No money will be charged or held in your account before the end of your trial period. After the trial period, your monthly subscription will start.
                </div> : null}
                {isEditable ?
                    <div className="text-right">
                        {disableField ? <CustomButton button='secondary' type='button' onClick={disablehandler}>
                            Edit
                        </CustomButton> : null}
                        {!disableField ? <CustomButton inProgress={inProgress} button='primary' type='submit'>
                            Save
                        </CustomButton> : null}
                    </div>
                    : <>
                        <CustomButton inProgress={inProgress} button='primary' size='big' type='submit'>
                            Confirm
                        </CustomButton>
                    </>}
                {error && <ErrorMessage text={error.error.message} />}
            </Form>
        </div>

    )
}

export default CreditCard
